import {
  ExportPayrollLineItemsDocument,
  ExportPayrollLineItemsMutation,
} from 'generated/resources/graphql'

import { useMutation } from 'modules/core/hooks/useMutation'
import { handleResult } from 'modules/core/lib/handleMutation'
import i18n from 'modules/core/lib/i18n'
import app from 'modules/core/store/models/app'

import { TableDataVariables } from 'modules/finance/components/FinancialWorkspace/types/table'
import { getGroupBy } from 'modules/finance/components/FinancialWorkspacePayroll/lib/groupBy'

export const useOnExport = (variables: TableDataVariables) => {
  const [exportPayrollLineItems] = useMutation(ExportPayrollLineItemsDocument, {
    extractorFn: (data: ExportPayrollLineItemsMutation) =>
      data.financialWorkspaceMutations.exportFinancialworkspaceExportExportPayrollLineItem,
  })

  const onExport = async () => {
    const result = await exportPayrollLineItems({
      variables: {
        ...variables,
        groupBy: getGroupBy(variables.groupBy),
      },
    })

    const handledResult = handleResult(result, () => undefined)

    if (handledResult.success) {
      app.setFlash({
        type: 'correct',
        message: i18n.t('data_table.export.success'),
        time: 3000,
      })
    } else {
      app.setFlash({
        type: 'wrong',
        message: i18n.t('errors.generic_error'),
      })
    }
  }

  return {
    onExport,
  }
}
